import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import '@/assets/style/base.scss'
import router from './router'
import App from './App.vue'
import vuescroll from 'vuescroll'
Vue.config.productionTip = false
Vue.use(vuescroll, {
  ops: {
    vuescroll: {
      mode: 'native',
      detectResize: true //内容是否根据页面调整
    },
    bar: {
      showDelay: 500,
      onlyShowBarOnScroll: false, //是否只有滚动的时候才显示滚动条
      keepShow: false,
      background: 'rgba(255, 255, 255, 0.6)',
      opacity: 1,
      hoverStyle: false,
      specifyBorderRadius: false,
      minSize: false,
      size: '6px',
      disable: false,
      overflowX: 'hidden'
    },
    scrollPanel: {
      speed: 800, //多长时间内完成一次滚动。 数值越小滚动的速度越快。
      easing: 'easeInQuad' //默认动画
    }
  },
  name: 'vueScroll' // 在这里自定义组件名字，默认是vueScroll
})
Vue.component('vueScroll', vuescroll)
Vue.use(ElementUI)
new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
